import apiClient from './api';

export interface LocationItem {
  id: string;
  name: string;
  nameLocal?: string;
}

export const locationService = {
  /**
   * Get all districts (municipalities)
   */
  async getDistricts(): Promise<LocationItem[]> {
    try {
      const response = await apiClient.get<LocationItem[]>('/address/getDistrictAsync');
      console.log('Districts response:', response.data);
      return response.data || [];
    } catch (error) {
      console.error('Error fetching districts:', error);
      throw error;
    }
  },

  /**
   * Get sub-districts (posto administrativo) by district ID
   */
  async getSubDistricts(districtId: string): Promise<LocationItem[]> {
    try {
      console.log('Fetching sub-districts for district ID:', districtId);
      const response = await apiClient.get<any>(`/address/getSubDistrictAsync/${districtId}`);
      console.log('Sub-districts response:', response.data);
      return response.data || [];
    } catch (error) {
      console.error('Error fetching sub-districts:', error);
      throw error;
    }
  },

  /**
   * Get sucos by sub-district ID
   */
  async getSucos(subDistrictId: string): Promise<LocationItem[]> {
    try {
      const response = await apiClient.get<any>(`/address/getSucoAsync/${subDistrictId}`);
      return response.data || [];
    } catch (error) {
      console.error('Error fetching sucos:', error);
      throw error;
    }
  },

  /**
   * Get aldeias by suco ID
   */
  async getAldeias(sucoId: string): Promise<LocationItem[]> {
    try {
      const response = await apiClient.get<any>(`/address/getAldeiaAsync/${sucoId}`);
      return response.data || [];
    } catch (error) {
      console.error('Error fetching aldeias:', error);
      throw error;
    }
  },

  /**
   * Helper function to fetch location data with retry logic
   * @param fn - The function to retry
   * @param maxRetries - Maximum number of retries (default: 2)
   * @param delayMs - Delay between retries in milliseconds (default: 1000)
   */
  async withRetry<T>(
    fn: () => Promise<T>,
    maxRetries: number = 2,
    delayMs: number = 1000
  ): Promise<T> {
    let lastError: unknown;
    for (let attempt = 0; attempt <= maxRetries; attempt++) {
      try {
        return await fn();
      } catch (error) {
        lastError = error;
        if (attempt < maxRetries) {
          console.warn(`Request failed, retrying (${attempt + 1}/${maxRetries})...`);
          await new Promise(resolve => setTimeout(resolve, delayMs));
        }
      }
    }
    throw lastError;
  },
};
